window.env = window.env || {}

export const discountApiHost: string = (window.env as any).DISCOUNT_API_HOST
export const offerWithProductApiHost: string = (window.env as any).PRODUCT_API_HOST
